import { Alert } from '@cmsgov/design-system'
import { MyInternalLink } from 'components/MyLink'
import { useEvent } from 'hooks/useEvent'
import { Trans, useTranslation } from 'react-i18next'

export function EasyPaySignupAlert () {
  const { t } = useTranslation('makeAPaymentPage', { keyPrefix: 'payYourPremium.easyPaySignupAlert' })

  return (
    <Alert heading={t('heading')} className='ds-u-measure--wide'>
      <Trans t={t} i18nKey="content" components={{
        link1: <LinkToEasyPay activityType='setupeasypay'/>,
        link2: <LinkToEasyPay activityType='easypaypage'/>
      }} />
    </Alert>
  )
}

export default EasyPaySignupAlert

function LinkToEasyPay ({ children, activityType }: {children?: React.ReactNode, activityType: 'setupeasypay' | 'easypaypage'}) {
  const { fireEvent } = useEvent('premiumsMakeAPayment')
  return <MyInternalLink
            to="/premiums/easy-pay"
            onClick={({ linkText, linkUrl }) => {
              fireEvent(`premiums_makeapayment_${activityType}_click`, {
                linkText,
                linkUrl
              })
            }}>{children}
         </MyInternalLink>
}
